import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import { useMemo } from 'react';
import {
  downloadProductManagementErrorSummary,
  downloadProductsManagementInputFile,
} from '@/activityLog/productsManagement/productManagementApi/productsManagementApi.ts';
import { useTranslation } from 'react-i18next';

export const useProductsManagementRowActions = () => {
  const { t } = useTranslation();

  return useMemo(() => {
    return [
      {
        label: t('bulkProvisioning.downloadFailedResults'),
        icon: <CloseIcon />,
        enabled: (data: any) => !!data.errorSummaryFileName,
        actionCallback: (data: any) => {
          downloadProductManagementErrorSummary(data.id);
        },
      },
      {
        label: t('bulkProvisioning.downloadInput'),
        icon: <DownloadIcon />,
        actionCallback: (data: any) => {
          downloadProductsManagementInputFile(data.id);
        },
        slotProps: {
          menuItem: {
            'data-testid': 'downloadInputFileButton',
          },
        },
      },
    ];
  }, []);
};
